import PropTypes from "prop-types"
import * as R from "ramda"

export const DATE_FORMAT = "YYYY-MM-DD"

export const MONTH_FORMAT = "YYYY-MM"

export const DATE_MODES = {
  SINGLE: "single",
  INTERVAL: "interval",
  MONTH: "month",
  ANYTIME: "anytime",
  TIME_TO_STAY: "timeToStay",
  NO_RETURN: "noReturn",
  PRICE_GRAPH: "priceGraph",
}

export const DATE_SHAPE = {
  mode: PropTypes.string.isRequired,
  from: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
  minStayDays: PropTypes.number.isRequired,
  maxStayDays: PropTypes.number.isRequired,
  final: PropTypes.bool.isRequired,
}

export const DATE_MODE_KEYS = {
  [DATE_MODES.SINGLE]: __("form_search.specific"),
  [DATE_MODES.INTERVAL]: __("form_search.interval"),
  [DATE_MODES.MONTH]: __("form_search.months"),
  [DATE_MODES.TIME_TO_STAY]: __("form_search.time_to_stay"),
  [DATE_MODES.ANYTIME]: __("form_search.anytime"),
  [DATE_MODES.NO_RETURN]: __("form_search.no_return"),
  [DATE_MODES.PRICE_GRAPH]: __("form_search.price_graph"),
}

export const OUTBOUND_DATE_MODES = [
  DATE_MODES.SINGLE,
  DATE_MODES.INTERVAL,
  DATE_MODES.ANYTIME,
  // DATE_MODES.PRICE_GRAPH
]

export const MULTICITY_OUTBOUND_DATE_MODES = [
  DATE_MODES.SINGLE,
  DATE_MODES.INTERVAL,
  // DATE_MODES.PRICE_GRAPH
]

export const INBOUND_DATE_MODES = [
  DATE_MODES.SINGLE,
  DATE_MODES.INTERVAL,
  DATE_MODES.TIME_TO_STAY,
  DATE_MODES.ANYTIME,
  DATE_MODES.NO_RETURN,
  // DATE_MODES.PRICE_GRAPH
]

export const DEPARTURE_DATE_MODES = [DATE_MODES.SINGLE, DATE_MODES.INTERVAL]
export const RETURN_DATE_MODES = [
  DATE_MODES.SINGLE,
  DATE_MODES.INTERVAL,
  DATE_MODES.TIME_TO_STAY,
  DATE_MODES.ANYTIME,
]

export const RANGE_DATE_MODES = [DATE_MODES.INTERVAL, DATE_MODES.ANYTIME]

export const TIME_TO_STAY_DATE_MODES = [DATE_MODES.TIME_TO_STAY]

export const DATE_LINK_SHAPE = {
  value: PropTypes.object.isRequired,
  opposite: PropTypes.object,
  field: PropTypes.string.isRequired,
  mode: PropTypes.oneOf(R.values(DATE_MODES)),
  onHide: PropTypes.func.isRequired,
  onActive: PropTypes.func.isRequired,
  requestChange: PropTypes.func.isRequired,
  isActive: PropTypes.bool.isRequired,
}

export const DATE_CB_SHAPE = {
  [DATE_MODES.SINGLE]: PropTypes.func,
  [DATE_MODES.INTERVAL]: PropTypes.func,
  [DATE_MODES.MONTH]: PropTypes.func,
  [DATE_MODES.TIME_TO_STAY]: PropTypes.func,
  [DATE_MODES.ANYTIME]: PropTypes.func,
  [DATE_MODES.NO_RETURN]: PropTypes.func,
}

// types
// =====
export type DateMode = "single" | "interval" | "month" | "anytime" | "timeToStay" | "noReturn"

export type Date = {
  mode: string,
  from: string,
  to: string,
  minStayDays: number,
  maxStayDays: number,
  final: boolean,
}

export type DateLink = {
  value: Date,
  opposite: ?Date,
  field: string,
  mode: DateMode,
  onHide: void => void,
  onActive: void => void,
  requestChange: any => void,
  isActive: boolean,
}

export type SimpleDatePicker = {
  maxDate: ?string,
  mindate: ?string,
  modes: Array<DateMode>,
}
